import { render, staticRenderFns } from "./SysDictDataList.vue?vue&type=template&id=573b89f2&scoped=true"
import script from "./SysDictDataList.vue?vue&type=script&lang=js"
export * from "./SysDictDataList.vue?vue&type=script&lang=js"
import style0 from "./SysDictDataList.vue?vue&type=style&index=0&id=573b89f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b89f2",
  null
  
)

export default component.exports